import { SagaIterator } from '@redux-saga/core';
import { all, takeLatest, put, call, takeEvery } from 'redux-saga/effects';

import { statusMessageSaga } from 'pages/AppManagement/saga';
import { RequestSagaParams } from 'types';

import { isArray, isEmpty } from 'lodash';
import * as Actions from './slice';
import * as Endpoints from './endpoints';

export function* fetchToken({ payload }: RequestSagaParams): SagaIterator {
  try {
    const response = yield call(Endpoints.fetchToken, payload);
    yield put(Actions.fetchTokenSuccess(response.data.token));
  } catch (error: any) {
    yield call(statusMessageSaga, { type: 'error', message: error?.message || error?.detail });
    yield put(Actions.fetchTokenFailure(error));
  }
}

export function* fetchBusinessGroup({ payload }: RequestSagaParams): SagaIterator {
  try {
    const response = yield call(Endpoints.fetchBusinessGroup);
    yield put(Actions.fetchBusinessGroupSuccess(response.data.choices));
  } catch (error: any) {
    yield call(statusMessageSaga, { type: 'error', message: error?.message || error?.detail });
    yield put(Actions.fetchBusinessGroupFailure(error));
  }
}

export function* fetchEngagementWidgetData({ payload }: RequestSagaParams): SagaIterator {
  try {
    // if (payload.objectKey === 'engagementOverTime') {
    //   const response = yield call(Endpoints.fetchEngagementWidgetData, 'engagements-over-time', payload.startTime,
    //     payload.endTime);
    //   yield put(
    //     Actions.fetchEngagementWidgetDataSuccess({
    //       data: response.data,
    //       key: payload.objectKey,
    //     })
    //   );
    // } else
    if (
      payload.objectKey === 'engagementOverTime' ||
      payload.objectKey === 'countries' ||
      payload.objectKey === 'devices' ||
      payload.objectKey === 'os' ||
      payload.objectKey === 'browser'
    ) {
      const response = yield call(
        Endpoints.fetchEngagementWidgetData,
        payload.key,
        payload.startTime,
        payload.endTime,
        payload.videoIds
      );
      yield put(
        Actions.fetchEngagementWidgetDataSuccess({
          data: response.data,
          key: payload.objectKey
        })
      );
    } else {
      const response = yield call(
        Endpoints.fetchEngagementWidgetData,
        payload.key,
        payload.startTime,
        payload.endTime,
        payload.videoIds
      );
      yield put(
        Actions.fetchEngagementWidgetDataSuccess({
          data: isArray(response.data)
            ? isEmpty(response.data)
              ? { value: 0, change: 0 }
              : {
                  value: response.data[0].current,
                  change: response.data[0].percentChange
                }
            : response.data,
          key: payload.objectKey
        })
      );
    }
  } catch (error: any) {
    yield call(statusMessageSaga, { type: 'error', message: error?.message || error?.detail });
    yield put(Actions.fetchEngagementWidgetDataFailure(error));
  }
}

// export function* fetchEngagementOverTimeData({ payload }: RequestSagaParams): SagaIterator {
//   try {
//     const response = yield call(Endpoints.fetchEngagementOverTimeData);
//     yield put(Actions.fetchEngagementWidgetDataSuccess({
//       data: response.data,
//       key: 'EngagementOverTime'
//     }));
//   } catch (error: any) {
//     yield call(statusMessageSaga, { type: 'error', message: error?.message || error?.detail });
//     yield put(Actions.fetchEngagementWidgetDataFailure(error));
//   }
// }

export function* AnalyticsManagementWatcherSaga(): SagaIterator {
  yield all([yield takeLatest(Actions.fetchToken.type, fetchToken)]);
  yield all([yield takeLatest(Actions.fetchBusinessGroup.type, fetchBusinessGroup)]);
  yield all([yield takeEvery(Actions.fetchEngagementWidgetData.type, fetchEngagementWidgetData)]);
}

export default AnalyticsManagementWatcherSaga;
